import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { moveWorkspaceFolders } from '../../../api/workspaces/folders/moveWorkspaceFolders';

export function useMoveWorkspaceFolders() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: moveWorkspaceFolders,
    onSettled: (data, error, { workspaceId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.folders({ workspaceId })
      );
    },
  });
}
